import {INavigateClientPageActionPayload} from "@sparkware/uc-sdk-core";
import {ActionHandlerBase} from "../action-handler-base";

export class NavigateClientPageActionHandler extends ActionHandlerBase<INavigateClientPageActionPayload> {
    async handle(payload: INavigateClientPageActionPayload): Promise<void> {
        await this.services.location.push(payload.actionData.url)
    }

}